export default __webpack_public_path__ + "static/media/hero_desktop_int.3df4213b.jpeg";